import React, {useState} from 'react';
import * as R from 'ramda';
import {addUserConnection} from '../../../../actions/facilita-api';
import {ServiceCard} from './serviceCard';
import { PersonalServices, OtherService, ConnectionTypes,SocialNetworksOptions, AssuranceOptions, convertConnectionTypesToServiceType } from '../../../../constants/utils/connectionTypes';
import { useDispatch } from 'react-redux';
import { ServicesEdit } from '../_common/serviceEdit';

export const DossierPersonal = ({connectionTypes, userId, user, serviceDatas, isLoading, generateLetters, isDemo}) => {
	const dispatch = useDispatch();
	const [selectedUserConnection, setSelectedUserConnection] = useState(undefined);

	function addConnection(userId, service){
		if(!connectionTypes.some(c => c.connectionType === service.connectionType))
			dispatch(addUserConnection(userId, service));
	}

	return (
		<article className="view-calc pt-4 mb-auto">
			<div className="container-fluid">
				<section className="block">
					<h4 className="h6 lh-copy text-uppercase font-weight-bolder mt-2 mb-1">Vie quotidienne à sélectionner : </h4>
					<form className="grid-sm grid-sm-min grid-lg-demarche py-sm">
						{
							R.sortWith([R.ascend(R.prop('title'))])(Object.values(PersonalServices)).map((srv, index) => {
								let progress = serviceDatas.some(s => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType)) ? 100 : 0;
								return <ServiceCard key={'personal' + index} progress={progress} isSelected={connectionTypes.some(c => c.connectionType === srv.connectionType)} service={srv} addOrRemove={() => addConnection(userId, srv)} setSelectedUserConnection={setSelectedUserConnection} isDemo={isDemo} />
							})
						}
						{
							Object.values(OtherService).filter(o => o.connectionType !== ConnectionTypes.activity && o.connectionType !== ConnectionTypes.pension && o.connectionType !== ConnectionTypes.otherActivity && o.connectionType !== ConnectionTypes.poleEmploi && o.connectionType !== ConnectionTypes.locataire && o.connectionType !== ConnectionTypes.etudiant).map((srv, index) => {
								let progress = serviceDatas.some(s => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType)) ? 100 : 0;
								return <ServiceCard key={'other' + index} progress={progress} isSelected={connectionTypes.some(c => c.connectionType === srv.connectionType)} service={srv} addOrRemove={() => addConnection(userId, srv)} setSelectedUserConnection={setSelectedUserConnection} isDemo={isDemo} />
							})
						}

					</form>
				</section>
				<section className="block mt-5 pt-2">
					<h4 className="h6 lh-copy text-uppercase font-weight-bolder mt-2 mb-1">SITUATION PROFESSIONNELLE ( à sélectionner) </h4>
					<form className="grid-sm grid-sm-min grid-lg-demarche py-sm">
						{
							Object.values(OtherService).filter(o => o.connectionType !== ConnectionTypes.other && o.connectionType !== ConnectionTypes.locataire).map((srv, index) => {
								let progress = serviceDatas.some(s => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType)) ? 100 : 0;
								return <ServiceCard key={'other_' + srv.connectionType + index} progress={progress} isSelected={connectionTypes.some(c => c.connectionType === srv.connectionType)} service={srv} addOrRemove={() => addConnection(userId, srv)} setSelectedUserConnection={setSelectedUserConnection} isDemo={isDemo} />
							})
						}
					</form>
				</section>
				 <section className="block mt-5 pt-2">
					<h4 className="h6 lh-copy text-uppercase font-weight-bolder mt-2 mb-1">RÉSEAUX SOCIAUX ( à sélectionner) </h4>
					<form className="grid-sm grid-sm-min grid-lg-demarche py-sm">
						{
							R.sortWith([R.ascend(R.prop('title'))])(Object.values(SocialNetworksOptions)).map((srv, index) => {
								let progress = 0;
								let isConnectionTypeSelected = connectionTypes.some(c => c.connectionType === srv.connectionType);
								if (serviceDatas.some(s => s.serviceType === convertConnectionTypesToServiceType(ConnectionTypes.socialNetworks)) && isConnectionTypeSelected) {
									progress = 100;
								}

								return <ServiceCard key={'social' + index} progress={progress} isSelected={isConnectionTypeSelected} isSocialNetwork={true} service={srv} addOrRemove={() => addConnection(userId, srv)} setSelectedUserConnection={setSelectedUserConnection} isDemo={isDemo} />
							})
						}
					</form>
				</section>
				<section className="block mt-5 pt-2">
					<h4 className="h6 lh-copy text-uppercase font-weight-bolder mt-2 mb-1">ASSURANCE ( à selectionner) </h4>
					 <form className="grid-sm grid-sm-min grid-lg-demarche py-sm">
						{
							R.sortWith([R.ascend(R.prop('title'))])(Object.values(AssuranceOptions)).map((srv, index) => {
								let connectionType = srv.connectionType;
								if (connectionType === ConnectionTypes.voitureAssurance || connectionType === ConnectionTypes.bateau || connectionType === ConnectionTypes.moto || connectionType === ConnectionTypes.scooter) {
									connectionType = ConnectionTypes.insurance;
								}
								let progress = 0;
								let isConnectionTypeSelected = connectionTypes.some(c => c.connectionType === srv.connectionType);
								if (serviceDatas.some(s => s.serviceType === convertConnectionTypesToServiceType(connectionType)) && isConnectionTypeSelected) {
									progress = 100;
								}
								return <ServiceCard key={'insurance' + index} progress={progress} isSelected={connectionTypes.some(c => c.connectionType === srv.connectionType)} isInsurance={true} service={srv} addOrRemove={() => addConnection(userId, srv)} setSelectedUserConnection={setSelectedUserConnection} isDemo={isDemo} />
							})
						}
					</form>
				</section>
			</div>
			<ServicesEdit  user={user} selectedUserConnection={selectedUserConnection} activeUserConnections={connectionTypes} serviceDatas={serviceDatas}  isLoading={isLoading} userId={userId} displayComments={false} disableModifications={generateLetters} generateLetters={generateLetters} isDemo={isDemo} />
		</article>
	)
}